import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from "rxjs/operators";

declare var $: any;

@Injectable()
export class HeaderHttpInterceptor implements HttpInterceptor {

    requests = 0;
    arrNoLoader = [
        '/assets',
        '/svg',
        '/user',
        '/language',
        '/store',
        '/notification',
        '/order/cart/',
        '/google-place',
        '/store-product/',
        'GetNotification'
    ];

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.requests = this.requests + 1;
        let countLoaderBlock = 0;
        if (req.body != null && req.body.operationName != null) {
            this.arrNoLoader.map((e, i) => {
                if (req.body.operationName.indexOf(e) >= 0) {
                    countLoaderBlock++;
                }
            });
        }
        this.arrNoLoader.map((e, i) => {
            if (req.url.indexOf(e) >= 0) {
                countLoaderBlock++;
            }
        });
        if (countLoaderBlock === 0) {
            this.toggleLoader(true);
        }

        const token = localStorage.getItem('token') as string;
        const culture = localStorage.getItem('culture') as string;

        let newHeaders = req.headers;
        if (token != null) {
            newHeaders = newHeaders.append('Authorization', 'Bearer ' + token);
        }
        if (culture != null) {
            newHeaders = newHeaders.append('Culture', culture);
        }

        const authReq = req.clone({headers: newHeaders});
        return next.handle(authReq).pipe(
            finalize(() => {
                this.requests = this.requests - 1;
                if (this.requests === 0) {
                    this.toggleLoader(false);
                    // this.loading.hide();
                }
            })
        );
    }

    toggleLoader(b: boolean) {
        if (!b) {
            $('#loaderBox').fadeOut();
        } else {
            $('#loaderBox').fadeIn();
        }
    }

}
